import { render, staticRenderFns } from "./CheckoutPwpShow.vue?vue&type=template&id=4524ef64&scoped=true&"
import script from "./CheckoutPwpShow.vue?vue&type=script&lang=js&"
export * from "./CheckoutPwpShow.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutPwpShow.vue?vue&type=style&index=0&id=4524ef64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524ef64",
  null
  
)

export default component.exports